<template lang="pug">
#event-register(v-cloak)
  .box      
    .box-header.with-border.register-header
      .title
        span イベント情報登録
    .box-body.register-body
      // 日付・時間
      FormEventDatetimePicker(v-model="eventDatetime" :date.sync="eventDate" :startTime.sync="eventTimeFrom" :endTime.sync="eventTimeTo"
        key-name="日付・時間" name="event-date" placeholder="日付・時間" :validation-rules="{ required: true }" required
      )

      // 公開範囲
      FormInputEventTargetType(v-model="targetType")
      .register-row(v-show="1 <= targetType")
        .register-group
          .register-key
            span.key-name 公開先
            span.validation-label 必須
          .register-value.flex-wrap.send-targets
            .loading(v-if="isMountedBusy")
              b-spinner.spinner
              span 公開先読込中...
            button.btn.target-select-btn(v-else @click="showTargetSelectModal()") {{ headerTitle }}選択
            .event-target.d-flex(v-for="target in _targetEventTargetSelectModalModel")
              span.target-name.align-self-center {{ target.name }}
              b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteTarget(target)") X
          .error-messages(v-if="errors.has('event-targets')")
            div(v-for="error in errors.collect('event-targets')")
              label.error-message {{ error }}

      // 開催方法
      FormInputEventHoldType(v-model="holdType" :active="2 == planType")
        template(v-slot:question)
          HelpIcon(popoverId="form-input-event-hold-type-help" title="開催方法について")
            template(v-slot:text)
              span オンライン開催の場合、イベント当日にライブ配信することが出来ます。
              span ご家族は自宅からスマートフォンで視聴出来ます。
              br
              span ※ ベーシックプランで使用可能
      // 参加申し込み設定・参加申込み締切日、ベーシックプランのみ使用可能な機能
      FormCheck(v-model="needReply" key-name="参加申込設定" name="event-need-reply" label="参加申込み有り"
        :active="2 == planType" :disabled="planType != 2 || needReplyDisabled == true")
        template(v-slot:question)
          HelpIcon(popoverId="form-input-event-need-reply-help" title="参加申込みについて")
            template(v-slot:text)
              span ご家族がイベントの参加申込みをすることが出来ます。
              span 施設側では参加申込み状況を確認出来ます。
              br
              span オンライン開催の場合は「参加申込み有り」になります。
              br
              span ※ ベーシックプランで使用可能
      FormDatePicker(v-show="needReply == true" v-model="replyDeadline" :date.sync="replyDeadlineDate"
        key-name="参加申込み締切日" name="reply-deadline" placeholder="参加申込み締切日" required
      )

      // 場所・タイトル・内容・画像ファイル
      FormInput(v-model="place" key-name="場所" name="place" type="text" placeholder="場所" :maxlength="100"
        :validation-rules="{ required: true, max: 100 }" required)
      FormInput(v-model="title" key-name="タイトル" name="title" type="text" placeholder="タイトル" :maxlength="100"
        :validation-rules="{ required: true, max: 100 }" required)
      FormTextarea(v-model="description" key-name="内容" name="description" placeholder="内容" :maxlength="1000" :rows="7"
        :validation-rules="{ required: true, max: 1000 }" :styles="{ maxWidth: '600px', width: '600px' }" required)
      FormFile(v-model="imageFile" key-name="画像ファイル" name="image-file" comment="※ファイル選択しない場合は初期画像が表示されます"
        :file-name.sync="imageName" mimetype="image/*" width="450px" :validationRules="{}" clip)
        template(v-slot:question)
          HelpIcon(:title="'選択可能なファイルについて'" :text="'jpegもしくはpngを選択可能です。'")

      // プレビュー
      .register-row
        .register-group
          .register-key
            span.key-name プレビュー
          .register-value
            EventPreview(:date="eventDatetime" :timeFrom="eventTimeFrom" :timeTo="eventTimeTo" :place="place" :title="title"
              :description="description" :imageUrl="imageUrl" :holdType="holdType" :needReply="needReply" :replyDeadline="replyDeadline")
    .box-footer.with-border.register-footer
      ValidationAlert(v-model="showValidationAlert")
      .buttons
        button.btn.register-btn(@click="showConfirmModal()" type="button") 登録
        button.btn.cancel-btn(@click="gotoEventList()" type="button") キャンセル
  img(ref="defaultImage" :src="defaultImage" style="display: none;")

  OkCancelModal(v-model="showRegisterModal" title="イベント情報を登録しますか？" @ok="registerEvent")
  OkModal(v-model="showRegisterSuccessModal" title="登録に成功しました。" @ok="gotoEventList")
  EventTargetSelectModal(v-model="isTargetSelectModal" :selectOptions="tempEventTargetSelectModalModel" :headerTitle="headerTitle" @ok="updateTarget")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { needRefreshesStore } from "@/store/store";
import { EventListState } from "@/store/NeedRefreshes";
import { tabIndexesStore } from "@/store/store";

import CustomValidate from "@/commons/utils/CustomValidate";
import { PcUrl } from "@/commons/constants/PcUrl";
import EventsService, { EventPostModel, EventHoldType, EventTargetType } from "@/commons/services/Events";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import { PlanType } from "@/commons/services/Plans";
import ImgElementToBase64 from "@/commons/utils/ImgElementToBase64";
import uuid from "uuid";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import FormFile from "@/pc/components/forms/FormFile.vue";
import FormInputEventTargetType from "@/pc/components/forms/FormInputEventTargetType.vue";
import FormCheck from "@/pc/components/forms/FormCheck.vue";
import FormInputEventHoldType from "@/pc/components/forms/FormInputEventHoldType.vue";
import EventTargetSelectModal, { EventTargetSelectModalModel } from "@/pc/components/modals/EventTargetSelectModal.vue";
import EventPreview from "@/pc/basics/EventPreview.vue";
import FormEventDatetimePicker from "@/pc/components/forms/FormEventDatetimePicker.vue";
import FormDatePicker from "@/pc/components/forms/FormDatePicker.vue";

import eventDefaultImage from "@/assets/event-default.png";

/**
 * イベント登録画面コンポーネント
 */
@Component({
  components: {
    HelpIcon,
    OkCancelModal,
    OkModal,
    FormInput,
    FormTextarea,
    FormFile,
    FormInputEventTargetType,
    FormCheck,
    FormInputEventHoldType,
    EventTargetSelectModal,
    EventPreview,
    FormEventDatetimePicker,
    FormDatePicker,
    PageLoading,
    ValidationAlert
  },
  $_veeValidate: { validator: "new" }
})
export default class EventRegister extends Vue {
  /** イベントサービス */
  @Inject("EventsService") eventsService!: EventsService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;

  /** 画面初期表示読込み */
  isMountedBusy: boolean = false;
  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 宛先選択モーダル表示可否 */
  isTargetSelectModal: boolean = false;
  /** 登録確認モーダル表示可否 */
  showRegisterModal: boolean = false;
  /** 登録完了モーダル表示可否 */
  showRegisterSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** イベント日時 */
  eventDatetime: number | null = null;
  /** 日付 */
  eventDate: string = "";
  /** 開始時刻 */
  eventTimeFrom: string = "";
  /** 終了時刻 */
  eventTimeTo: string = "";
  /** 宛先種別 */
  targetType: EventTargetType | null = null;
  /** 開催方法 */
  holdType: EventHoldType = EventHoldType.LOCAL_ONLY;
  /** 参加申込設定 */
  needReply: boolean = false;
  /** 参加申し込み設定、値変更可否 */
  needReplyDisabled: boolean = false;
  /** 参加申込み締切日時 */
  replyDeadline: number = 0;
  /** 参加申込み締切日 */
  replyDeadlineDate: string | null = "";
  /** 場所 */
  place: string = "";
  /** タイトル */
  title: string = "";
  /** 内容 */
  description: string = "";
  /** ファイル選択コンポーネントで選択したファイル */
  imageFile: any = null;
  /** ファイル選択コンポーネントで選択したファイルのURL */
  imageUrl: string = "";
  /** ファイル選択コンポーネントで選択したファイル名 */
  imageName: string = "";
  /** イベントの画像が無い場合に表示するデフォルト画像 */
  defaultImage: string = eventDefaultImage;

  /** 宛先選択モーダルのタイトル */
  headerTitle: string = "利用者グループ";
  /** 宛先種別が「利用者グループ」の場合の宛先種別選択肢 */
  residentGroups: Array<EventTargetSelectModalModel> = [];
  /** 宛先 */
  eventTargetSelectModalModel: Array<EventTargetSelectModalModel> = [];
  /** 宛先選択肢(キャンセル等がありえるので一時コピーした宛先を子コンポーネントに渡す) */
  tempEventTargetSelectModalModel: Array<EventTargetSelectModalModel> = [];

  /**
   * ### 開催方法の変更イベント
   *
   * - オンライン開催、現地とオンライン開催の場合は強制的に参加申込設定をtrueにする
   * - 参加申込設定をtrueする場合は値変更不可にする
   */
  @Watch("holdType")
  public changeHoldType(newValue: EventHoldType): void {
    if (newValue == EventHoldType.ONLINE_ONLY || newValue == EventHoldType.LOCAL_AND_ONLINE) {
      this.needReply = true;
      this.needReplyDisabled = true;
    } else {
      this.needReplyDisabled = false;
    }

    return;
  }

  /**
   * FileSelecterコンポーネントにバインドした画像の変更イベント
   * ファイル選択、ファイル削除時に呼ばれる
   */
  @Watch("imageFile")
  public async changeImageFile(newFile: string): Promise<void> {
    if (newFile) {
      this.imageUrl = newFile;
    } else {
      this.imageUrl = "";
    }

    return;
  }

  get _targetEventTargetSelectModalModel(): Array<EventTargetSelectModalModel> {
    let targets: Array<EventTargetSelectModalModel> = [];

    for (const target of this.eventTargetSelectModalModel) {
      if (target.isChecked == true) {
        targets.push(target);
      }
    }

    return targets;
  }

  /**
   * ### vue lifecycle created
   */
  public created() {
    CustomValidate.addCustomValidate(this.$validator);

    // 日付の初期値を作成する
    const eventDate: string = this.$dateUtil.convertDateToString(new Date(), "yyyy-mm-dd");
    this.eventDate = eventDate;
    this.eventTimeFrom = "10:00:00";
    this.eventTimeTo = "11:00:00";

    const today: Date = new Date();
    this.replyDeadline = this.$dateUtil.convertDateToNumber(today, "yyyymmdd000000000");
    this.replyDeadlineDate = this.$dateUtil.convertDateToString(today, "yyyy-mm-dd");

    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.planType = userStore.facility.planType;
    this.holdType = EventHoldType.LOCAL_ONLY;
    await this.createView();

    return;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    this.isMountedBusy = true;

    const groups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    let residentGroups: Array<EventTargetSelectModalModel> = [];
    for (const group of groups) {
      const residentGroup: EventTargetSelectModalModel = {
        name: group.name,
        id: group.id,
        isChecked: false
      };
      residentGroups.push(residentGroup);
    }
    this.residentGroups = residentGroups;

    this.isMountedBusy = false;

    return;
  }

  /**
   * ### 利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const groups: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return groups;
  }

  /**
   * ### 宛先選択モーダルを表示する
   */
  public showTargetSelectModal(): void {
    switch (this.targetType) {
      case EventTargetType.RESIDENT_GROUP: {
        this.eventTargetSelectModalModel = this.residentGroups;
        break;
      }
      default: {
        this.eventTargetSelectModalModel = [];
      }
    }

    this.tempEventTargetSelectModalModel = JSON.parse(JSON.stringify(this.eventTargetSelectModalModel));
    this.isTargetSelectModal = true;

    return;
  }

  /**
   * ### 宛先選択結果を格納する
   */
  public updateTarget(targets: Array<EventTargetSelectModalModel>): void {
    switch (this.targetType) {
      case EventTargetType.RESIDENT_GROUP: {
        this.residentGroups = targets;
        this.eventTargetSelectModalModel = this.residentGroups;
        break;
      }
      default: {
        this.eventTargetSelectModalModel = [];
      }
    }

    return;
  }

  /**
   * ### 宛先を削除する
   */
  public deleteTarget(target: EventTargetSelectModalModel): void {
    target.isChecked = false;
    return;
  }

  /**
   * ### 登録確認モーダルを表示する
   *
   * - 表示前にバリデーションチェックして、エラーならモーダルは表示しない
   */
  public async showConfirmModal(): Promise<void> {
    // チェック結果を初期化してからチェックしないと、エラーメッセージが残り続けてしまう
    this.$validator.errors.remove("event-targets");

    const validationResult: boolean = await this.$validator.validateAll();
    const eventDateValidationResult: boolean = this.validateEventDate(this.eventDatetime);
    const eventTargetsValidationResult: boolean = this.validateEventTarget(this.targetType as EventTargetType, this.eventTargetSelectModalModel);
    const replyDeadlineValidationResult: boolean = this.validationReplyDeadline(this.needReply as boolean, this.replyDeadline, this.eventDatetime);
    const eventTimeValidationResult: boolean = this.validationEventTime(this.eventTimeFrom, this.eventTimeTo, this.holdType as EventHoldType);

    if (
      validationResult == true &&
      eventDateValidationResult == true &&
      eventTargetsValidationResult == true &&
      replyDeadlineValidationResult == true &&
      eventTimeValidationResult == true
    ) {
      this.showValidationAlert = false;
      this.showRegisterModal = true;
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /**
   * ### 日付バリデーション
   *
   * - 実際に存在する日付かチェック
   * - 引数がnullの場合は必須チェックでエラーになるのでtrueを返す
   */
  public validateEventDate(eventDate: number | null): boolean {
    if (eventDate == null) {
      return true;
    }

    const existDate = this.$dateUtil.checkExistDate(eventDate);
    return existDate;
  }

  /**
   * ### 宛先バリデーション
   *
   * - 必須入力チェック
   */
  public validateEventTarget(targetType: EventTargetType, targets: Array<EventTargetSelectModalModel>): boolean {
    if (targetType == EventTargetType.ALL) {
      return true;
    }

    for (const target of targets) {
      if (target.isChecked == true) {
        return true;
      }
    }

    this.$validator.errors.add({ field: "event-targets", msg: "公開先は必須項目です" });

    return false;
  }

  /**
   * ### 参加申込み締切日のバリデーション
   *
   * - 参加申込み有りの場合は必須チェック
   * - 実際に存在する日付かチェック
   */
  public validationReplyDeadline(needRply: boolean, replyDeadline: number, eventDatetime: number | null): boolean {
    let replyDeadlineValidationResult: boolean = true;

    if (needRply == true) {
      if (!replyDeadline) {
        this.$validator.errors.add({ field: "reply-deadline", msg: "参加申込み締切日は必須項目です" });
        replyDeadlineValidationResult = false;
      } else {
        const existDate = this.$dateUtil.checkExistDate(replyDeadline);
        if (existDate == false) {
          this.$validator.errors.add({ field: "reply-deadline", msg: "参加申込み締切日は存在しない年月日です" });
          replyDeadlineValidationResult = false;
        }

        if (eventDatetime != null) {
          const slicedEventDatetime: string = eventDatetime.toString().slice(0, 8);
          const slicedReplyDeadline: string = replyDeadline.toString().slice(0, 8);

          if (Number(slicedEventDatetime) < Number(slicedReplyDeadline)) {
            this.$validator.errors.add({ field: "reply-deadline", msg: "参加申込み締切日が日付より未来です" });
            replyDeadlineValidationResult = false;
          }
        }
      }
    }

    return replyDeadlineValidationResult;
  }

  /**
   * ### イベント時間のバリデーション
   *
   * - 実施種別がオンラインに関わる場合はイベント実施時間は1時間までに制限する
   */
  public validationEventTime(from: string, to: string, holdType: EventHoldType): boolean {
    let validationResult: boolean = true;

    if (holdType == EventHoldType.LOCAL_AND_ONLINE || holdType == EventHoldType.ONLINE_ONLY) {
      const fromHour: number = Number(from.slice(0, 2));
      const fromMin: number = Number(from.slice(3, 5));
      const totalFromMin: number = fromHour * 60 + fromMin;
      const toHour: number = Number(to.slice(0, 2));
      const toMin: number = Number(to.slice(3, 5));
      const totalToMin: number = toHour * 60 + toMin;

      if (60 < totalToMin - totalFromMin) {
        this.$validator.errors.add({ field: "timepicker-from", msg: "オンラインイベントの場合、実施時間は1時間までです" });
        validationResult = false;
      }
    }

    return validationResult;
  }

  /**
   * ### イベント登録
   */
  public async registerEvent(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中...";

    const requestBody: EventPostModel = this.createRequestBody();
    await this.eventsService.post(userStore, requestBody);

    // イベント一覧を再読み込みさせるようstoreを更新
    let eventList: EventListState = needRefreshesStore.eventList;
    eventList.eventList = true;
    needRefreshesStore.setEventList(eventList);

    // 登録成功ダイアログを表示する
    this.showRegisterSuccessModal = true;

    // イベント新規登録後に一覧に戻った際、タブを「非公開のみ」に移動させたいのでstoreに保持させる
    tabIndexesStore.setEventTabIndex({ index: 1 });

    this.isBusy = false;

    return;
  }

  /**
   * ### イベント登録パラメータ作成
   *
   * - 画像をBase64エンコードした情報を作成する
   *   - 画像が指定されていない場合はデフォルト画像を使用する
   * - イベント日時はイベント日時を変換したものを使用する
   * - 宛先種別が「全て」以外(利用者グループ以上)の場合は宛先を作成する
   * - 作成した情報からリクエストボディを作成する
   */
  public createRequestBody(): EventPostModel {
    if (!this.imageUrl) {
      const img: any = this.$refs.defaultImage;
      this.imageUrl = ImgElementToBase64.convert(img, "image/jpeg");
    }

    const eventDate: string = this.$dateUtil.replaceNonNumeric(this.eventDate);

    let targets: number[] = [];
    if (this.targetType != null && EventTargetType.RESIDENT_GROUP <= this.targetType) {
      for (const target of this.eventTargetSelectModalModel) {
        if (target.isChecked == true) {
          targets.push(target.id);
        }
      }
    }

    let replyDeadline: number | undefined = undefined;
    if (this.needReply == true) {
      const slicedReplyDeadline: string = this.replyDeadline.toString().slice(0, 8);
      replyDeadline = Number(`${slicedReplyDeadline}235959000`);
    }

    let meetingToken: string = "";
    if (this.holdType == EventHoldType.LOCAL_AND_ONLINE || this.holdType == EventHoldType.ONLINE_ONLY) {
      meetingToken = uuid.v4();
    }

    const requestBody: EventPostModel = {
      date: Number(this.eventDatetime),
      timeFrom: Number(`${eventDate}${this.convertEventTime(this.eventTimeFrom)}`),
      timeTo: Number(`${eventDate}${this.convertEventTime(this.eventTimeTo)}`),
      targetType: this.targetType as EventTargetType,
      targets: targets,
      needReply: this.needReply,
      replyDeadline: replyDeadline,
      holdType: this.holdType as EventHoldType,
      place: this.$stringUtil.convertYen(this.place),
      title: this.$stringUtil.convertYen(this.title),
      description: this.$stringUtil.convertYen(this.description),
      image: this.imageUrl,
      meetingToken: meetingToken,
      writtenBy: userStore.loginUser.name,
      writerId: userStore.loginUser.userId
    };

    return requestBody;
  }

  /**
   * 文字列の時刻(hh:MM)を数値の日付(yyymmddhhMMssSSS)に変換する
   * - 時刻は時分の形式(例 00:20)なので、「:」を削除して、秒の部分を加える
   *   timepickerコンポーネントの仕様により、3桁(8:30等)がありえるので、3桁なら先頭を0埋めする
   *   ※分は2桁が約束されているので、1桁かどうかを意識するのは時間だけ
   */
  public convertEventTime(time: string): string {
    const nonNumeriTime: string = this.$dateUtil.replaceNonNumeric(time);
    return `${nonNumeriTime}000`;
  }

  /**
   * イベント一覧に遷移する
   */
  public gotoEventList(): void {
    this.$router.push(PcUrl.EventList);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

#event-register {
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;

  .register-btn,
  .cancel-btn {
    width: 120px;
  }

  .target-select-btn {
    margin: 0 8px 4px 0;
  }
  .event-target {
    display: inline-block;
    padding: 7px;
    font-size: 16px;
    margin: 0 8px 4px 0;
    border-radius: 3px;
    transition: all 0.2s;
    border: 1px solid $form-border-color;

    .target-name {
      margin: 0 8px 0 0 !important;
    }
    .delete-btn {
      margin: 0 !important;
      font-size: 14px !important;
    }
  }
}
</style>
